import { Model } from 'modules/core/lib/mobx-rest'
import type { Analytic } from 'modules/core/store/models/Analytic'

export interface Attributes {
  id: number
  location_type: Analytic<number>
}

export const WORKING_LOCATION_RANGE_DAYS = 30

class TeamShiftLocationAnalytics extends Model<Attributes> {
  static urlRoot() {
    return '/analytics/attendance_shift_locations'
  }
}

export default TeamShiftLocationAnalytics
